// removed by extract-text-webpack-plugin
module.exports = {"component":"MedicineList__component___1w-69","title":"MedicineList__title___3DsAD","showMoreLink":"MedicineList__showMoreLink___mO6Fa","button":"MedicineList__button___2wNtC"};


//////////////////
// WEBPACK FOOTER
// ./src/homepage/components/MedicineList.css
// module id = 424
// module chunks = 0